import { useEffect, useState } from "react";

import MusicNotesIcon from "../../assets/icons/musicNotesIcon";
import OpenInNewIcon from "../../assets/icons/openInNew";
import SoundcloudIcon from "../../assets/icons/socialMedia/soundcloudIcon";
import SpotifyIcon from "../../assets/icons/socialMedia/spotifyIcon";
import YoutubeIcon from "../../assets/icons/socialMedia/youtubeIcon";
import { getApiUrl } from "../../data/api/apiManager";
import { PerformanceResponseDTO } from "../../openapi-generated-client";
import { URLType } from "../../utils/urlUtils";
import CustomAudioPlayer from "../audioPlayer/customAudioPlayer";
import "./performanceDisplay.css";

const performanceTypeToIcon = {
    "SPOTIFY": <SpotifyIcon/>,
    "YOUTUBE": <YoutubeIcon/>,
    "SOUNDCLOUD": <SoundcloudIcon/>
}


interface PerformanceDisplayProps {
    performance: PerformanceResponseDTO;
}

export default function PerformanceDisplay(props: PerformanceDisplayProps) {

    const [icon, setIcon] = useState(<MusicNotesIcon/>);
    const [color, setColor] = useState("blue");
    const [name, setName] = useState("MP3");

    useEffect(() => {
        if(props.performance.type!.toString() === URLType[URLType.SPOTIFY]) {
            setIcon(<SpotifyIcon/>);
            setColor("green");
            setName("Spotify");
        }else if(props.performance.type!.toString() === URLType[URLType.YOUTUBE]) {
            setIcon(<YoutubeIcon/>);
            setColor("red");
            setName("YouTube");
        }else if(props.performance.type!.toString() === URLType[URLType.SOUNDCLOUD]) {
            setIcon(<SoundcloudIcon/>);
            setColor("yellow");
            setName("SoundCloud");
        }
    }, [props.performance]);

    return <div className="performance-display" key={props.performance.id}>
        <a href={"/artists/" + props.performance.performer.id}>{props.performance.performer.name}</a>
        <h6>{props.performance.description}</h6>
        <div className="link-box">
            <div className="icon-box" style={{backgroundColor: "var(--" + color + ")"}}>
                {icon}
            </div>
            {props.performance.type!.toString() === URLType[URLType.LOCAL] ?
            <CustomAudioPlayer src={getApiUrl("assets/by-hash/" + props.performance.link!)}/> :
            <>
            <h4>{name}</h4>
            <div className="open-link" onClick={() => {
                window.open(props.performance.link, "_blank");
            }}>
                <OpenInNewIcon/>
            </div>
            </>}
        </div>
    </div>
}